import { render, staticRenderFns } from "./ownerDiningList.vue?vue&type=template&id=d3498e50&scoped=true"
import script from "./ownerDiningList.vue?vue&type=script&lang=js"
export * from "./ownerDiningList.vue?vue&type=script&lang=js"
import style0 from "./ownerDiningList.vue?vue&type=style&index=0&id=d3498e50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3498e50",
  null
  
)

export default component.exports